import Image from "next/image";

import cn from "classnames";
import { Image as ImageType } from "sanity";

import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import { RichText as RichTextType } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const ReasonsToBuyItem = ({
  icon,
  title,
  description,
  className,
  layout = "stacked",
}: ReasonsToBuyItemProps) => {
  const imageUrl = icon ? urlFor(icon).url() : null;
  const inline = layout === "inline";

  return (
    <div
      className={cn(
        "rounded-lg",
        inline
          ? "flex flex-row items-start gap-3 text-left"
          : "flex flex-col items-center gap-2 bg-white text-center lg:p-8",
        className,
      )}>
      <div className="text-primary flex size-12 shrink-0 items-center justify-center lg:size-14">
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt=""
            width={56}
            height={56}
            className="size-full object-contain"
            unoptimized
          />
        ) : null}
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <Text
          variant={inline ? "subtitle2" : "h6"}
          component="h3"
          className="text-greyscale-headline">
          {title}
        </Text>
        <RichText>{description}</RichText>
      </div>
    </div>
  );
};

export type ReasonsToBuyItemProps = {
  icon?: ImageType;
  title: string;
  description?: RichTextType;
  className?: string;
  layout?: "stacked" | "inline";
};
